import { Col, Layout, Row, Typography } from "antd";
import React from "react";

const TermsAndConditions =() => {
  return (
    <Layout>
      <Layout.Content>
        <Row>
          <Col span={20} offset={2}>
            <Row justify="start">
              <Typography.Title level={4}>
                Terms and Conditions
              </Typography.Title>
            </Row>
            <Row>
              <Typography.Paragraph>Description...</Typography.Paragraph>
            </Row>
            <Row>
              <Typography.Title level={4}>Terms of Use</Typography.Title>
            </Row>
            <Row>
              <Typography.Paragraph>Description....</Typography.Paragraph>
            </Row>
          </Col>
        </Row>
      </Layout.Content>
    </Layout>
  );
}

export default TermsAndConditions;